import { render, staticRenderFns } from "./FolderItem.vue?vue&type=template&id=5e66c558"
import script from "./FolderItem.ts?vue&type=script&lang=js&external"
export * from "./FolderItem.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports